/* eslint-disable */
import PropTypes from 'prop-types'; // Import PropTypes
import { PieChart } from '@mui/x-charts';
import styles from './pieChartDB.module.scss';
import { formatValue } from './utils';


const PieChartDB = ({ data, visible, alignment }) => {
  const total = data.reduce((acc, platform) => acc + Number(platform.value), 0);
  const dataWithArcValues = data.map((platform) => ({
    ...platform,
    arcValue: total > 0 ? (Number(platform.value) / total) * 100 : 0,
  }));
  
  return (
    <div className={styles['pie-chart-container']}>
      <PieChart
        className={styles['pie-chart']}
        series={[
          {
            loading: true,
            innerRadius: 101,
            outerRadius: 122,
            paddingAngle: 0.5,
            cornerRadius: 20,
            id: 'platform-series',
            data: dataWithArcValues,
            valueKey: 'arcValue',
            arcBorderWidth: 0,
            cx: 190,
            cy: 150,
            animation: false,
            transitionDuration: 0,
          },
        ]}
        width={400}
        height={300}
        slotProps={{
          legend: { hidden: true },
        }}
      />
      <div className={styles['legend-container']}>
        {data.map((platform) => (
          <div key={platform?.label} className={styles['legend-item']}>
            <div className={styles['legend-row']}>
              <div
                className={styles['color-box']}
                style={{ backgroundColor: platform.color }}
              />
              <div className={styles['label']}>{platform.label}</div>
            </div>
            <div
              className={`${styles['value']} ${visible ? styles['fade-in'] : styles['fade-out']
                }`}
            >
              {alignment === "Value" ? "$" : ""}
              {formatValue(platform.value, alignment)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Add propTypes validation
PieChartDB.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      color: PropTypes.string.isRequired,
    })
  ).isRequired,
  visible: PropTypes.bool.isRequired,
  alignment: PropTypes.string.isRequired,
};

export default PieChartDB;

PieChartDB.propTypes = {
  data: PropTypes.any,
  visible: PropTypes.any,
  alignment: PropTypes.any,
};